import { render } from "./freeText.vue?vue&type=template&id=b1e4bede&scoped=true"
import script from "./freeText.vue?vue&type=script&lang=js"
export * from "./freeText.vue?vue&type=script&lang=js"

import "./freeText.vue?vue&type=style&index=0&id=b1e4bede&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1e4bede"]])

export default __exports__